import ChevronUpIcon from './ChevronUpIcon';
export default ChevronUpIcon;
